import React from 'react';
import Navbar from "./Navbar";
import Footer from "./Footer";
import './Instagram.css';
import ScrollToTop from "./ScrollToTop";


const Instagram1 = () => {
  return (
    <div>
        <Navbar />

        <div className='insta-main'>
            <p>Instagram Business / Fan Page Maintenance</p>

<div className='second-main'>
<div class="row row-cols-1 row-cols-md-3 g-4 second-main2">
  <div class="col-lg-4 col-md-6 col-sm-12" style={{cursor: 'pointer'}}>
    <div class="card">
      <img src="/Instagram - Client/oie_ag8j6FILU5IE.png" class="card-img-top" height="300" width="200" alt="..."/>
      <div class="card-body">
        <h5 class="insta-card-title">Amman Restaurant</h5>
        <p class="card-text"></p>
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-6 col-sm-12" style={{cursor: 'pointer'}}>
    <div class="card">
      <img src="/Instagram - Client/Balagopalan-Jewellery-mart-balagopalan_jewellery_mart-•-Instagram-photos-and-videos.png" class="card-img-top" height="300" width="200" alt="..."/>
      <div class="card-body">
        <h5 class="insta-card-title">Balagopalan Jewellery Mart</h5>
        <p class="card-text"></p>
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-6 col-sm-12" style={{cursor: 'pointer'}}>
    <div class="card">
      <img src="/Instagram - Client/Cool-World-Madurai-coolworld_madurai-•-Instagram-photos-and-videos.png" class="card-img-top" height="300" width="200" alt="..."/>
      <div class="card-body">
        <h5 class="insta-card-title">We Craft Floors</h5>
        <p class="card-text"></p>
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-6 col-sm-12" style={{cursor: 'pointer'}}>
    <div class="card">
      <img src="/Instagram - Client/Hi-Bro-Mens-Madurai-hi_bro_madurai-•-Instagram-photos-and-videos.png" class="card-img-top" height="300" width="200" alt="..."/>
      <div class="card-body">
        <h5 class="insta-card-title">Senthil Jewellery Mart</h5>
        <p class="card-text"></p>
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-6 col-sm-12" style={{cursor: 'pointer'}}>
    <div class="card">
      <img src="/Instagram - Client/Karthik-Karthik-varshanenterprises-•-Instagram-photos-and-videos.png" class="card-img-top" height="300" width="200" alt="..."/>
      <div class="card-body">
        <h5 class="insta-card-title">MK Oil Mill</h5>
        <p class="card-text"></p>
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-6 col-sm-12" style={{cursor: 'pointer'}}>
    <div class="card">
      <img src="/Instagram - Client/Kerala-Furniture-Gallery-keralafurniture_gallery-•-Instagram-photos-and-videos (1).png" class="card-img-top" height="300" width="200" alt="..."/>
      <div class="card-body">
        <h5 class="insta-card-title">Hi Bro Mens Madurai</h5>
        <p class="card-text"></p>
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-6 col-sm-12" style={{cursor: 'pointer'}}>
    <div class="card">
      <img src="/Facebook - Client/Facebook (7).png" class="card-img-top" height="300" width="200" alt="..."/>
      <div class="card-body">
        <h5 class="insta-card-title">Varshan Enterprises</h5>
        <p class="card-text"></p>
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-6 col-sm-12" style={{cursor: 'pointer'}}>
    <div class="card">
      <img src="/Facebook - Client/Facebook.png" class="card-img-top" height="300" width="200" alt="..."/>
      <div class="card-body">
        <h5 class="insta-card-title">Saaral bakes cakes sweets</h5>
        <p class="card-text"></p>
      </div>
    </div>
  </div>
</div>
</div>

</div>
<ScrollToTop />
<Footer />
    </div>
  )
}

export default Instagram1
